<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <ng-template [ngIf]="schemaShouldShowComplexForm">
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isPoolEmptyAndUncovered" formControlName="isPoolEmptyAndUncovered"
                               type="checkbox"
                               class="custom-control-input"
                               id="isPoolEmptyAndUncovered">
                        <label class="custom-control-label" for="isPoolEmptyAndUncovered">Is pool empty and uncovered?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isPoolWaterUnsanitary" formControlName="isPoolWaterUnsanitary"
                               type="checkbox"
                               class="custom-control-input"
                               id="isPoolWaterUnsanitary">
                        <label class="custom-control-label" for="isPoolWaterUnsanitary">Is pool water unsanitary?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isDamaged" formControlName="isDamaged"
                               type="checkbox"
                               class="custom-control-input"
                               id="isDamaged">
                        <label class="custom-control-label" for="isDamaged">Is the pool damaged?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isMissingEquipment" formControlName="isMissingEquipment"
                               type="checkbox"
                               class="custom-control-input"
                               id="isMissingEquipment">
                        <label class="custom-control-label" for="isMissingEquipment">Is the pool missing equipment?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="deficiencySeverity" formControlName="hasFenceSurrounding"
                               type="checkbox"
                               class="custom-control-input"
                               id="hasFenceSurrounding">
                        <label class="custom-control-label" for="hasFenceSurrounding">Pool does not have a fence surrounding it?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <div class="custom-control custom-checkbox">
                        <input name="isLanaiDamaged" formControlName="isLanaiDamaged"
                               type="checkbox"
                               class="custom-control-input"
                               id="isLanaiDamaged">
                        <label class="custom-control-label" for="isLanaiDamaged">Is the lanai Damaged?</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10 form-group-container" *ngFor="let formControl of formControl;">
                    <div *ngIf="formControl.control === smartTagFormControlType.MULTIPLE"
                         formGroupName="{{formControl.field}}">
                        <label class="custom-control-label label-title">{{formControl.title}}</label>
                        <div class="custom-control custom-checkbox" *ngFor="let item of innerForm.get(formControl.field)['controls']; let index=index">
                            <label class="custom-control-label">
                                <input [formControlName]="index"
                                       type="checkbox"
                                       class="custom-control-input form-check-input">{{formControl.options[index].label}}
                            </label>
                        </div>
                    </div>

                    <div *ngIf="formControl.control === smartTagFormControlType.SINGLE">
                        <label class="custom-control-label label-title">{{formControl.title}}</label>
                        <cv-dropdown
                                [placeholder]="formControl.title"
                                [optionText]="'label'"
                                [selectedValue]="dropdownInitialValues[formControl.field]"
                                [options]="formControl.options"
                                (valuesChange)="onDropdownValueChange(formControl.field, $event)">
                        </cv-dropdown>
                    </div>
                </div>
            </div>
        </ng-template>
        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
